export default "/img/MO.b64557e66bbce360824abd71a677047b.png";